/* Familiar basic carts, shown as illustrations of a standard setup. */
(() => {
  const designs = [
    {key: 'gruns', brand: 'grüns', title: 'Your cart', count: '3 items', variantOne: 'Black / Medium', variantTwo: 'Navy / Large', subtotal: 'Subtotal', shipping: 'Shipping calculated at checkout.', checkout: 'Check out', back: 'Continue shopping', remove: 'Remove'},
    {key: 'gud', brand: 'GUD', title: 'KOŠARICA', count: '3 izdelki', variantOne: 'Black / Medium', variantTwo: 'Navy / Large', subtotal: 'SKUPAJ', shipping: 'Dostava je obračunana ob zaključku nakupa.', checkout: 'NA BLAGAJNO', back: 'Nadaljuj z nakupovanjem', remove: 'Odstrani'},
    {key: 'velside', brand: 'VELSIDE', title: 'YOUR CART', count: '3 ITEMS', variantOne: 'BLACK / MEDIUM', variantTwo: 'NAVY / LARGE', subtotal: 'SUBTOTAL', shipping: 'Shipping and taxes calculated at checkout.', checkout: 'CHECKOUT', back: 'CONTINUE SHOPPING', remove: 'Remove'}
  ];
  const tee = '<svg viewBox="0 0 48 54" fill="none" aria-hidden="true"><path class="plain-cart__fabric" d="m15 8 6-3c1 5 5 5 6 0l6 3 10 11-7 7-4-5v26H16V21l-4 5-7-7L15 8Z"/><path d="M16 41h16M20 7c0 6 8 6 8 0M7 20l5 4m24 0 5-4"/></svg>';
  const hoodie = '<svg viewBox="0 0 48 54" fill="none" aria-hidden="true"><path class="plain-cart__fabric plain-cart__fabric--hoodie" d="M17 16c-4-15 18-15 14 0l5 3 6 23-8 2-3-15v19H17V29l-3 15-8-2 6-23 5-3Z"/><path d="M17 16c4 5 10 5 14 0M21 19v8m6-8v8M19 35h10l2 7H17l2-7ZM17 44h14"/></svg>';
  function quantity(value, design) {
    if (design.key === 'velside') return `<span class="plain-cart__quantity plain-cart__quantity--select">QTY <b>${value}</b><span>⌄</span></span>`;
    return `<span class="plain-cart__quantity"><span>−</span><span>${value}</span><span>+</span></span>`;
  }
  function product(icon, title, variant, count, price, design) {
    return `<div class="plain-cart__item"><div class="plain-cart__product-image">${icon}</div><div class="plain-cart__product-info"><p class="plain-cart__product-title">${title}</p><p class="plain-cart__variant">${variant}</p><span class="plain-cart__price">${price}</span>${quantity(count, design)}<span class="plain-cart__remove">${design.remove}</span></div></div>`;
  }
  function masthead(design) {
    if (design.key === 'gud') return `<div class="plain-cart__masthead"><span class="plain-cart__brand">G U D<small>· SHOP ·</small></span><span class="plain-cart__close">×</span></div>`;
    return `<div class="plain-cart__masthead"><span class="plain-cart__brand">${design.brand}${design.key === 'velside' ? '<small>OFFICIAL STORE</small>' : ''}</span><span class="plain-cart__close">×</span></div>`;
  }
  function render(index = 0) {
    const mount = document.getElementById('counter-cart-mount');
    if (!mount) return null;
    const design = designs[Number(index)] || designs[0];
    const tableHead = design.key === 'velside' ? '<div class="plain-cart__table-head"><span>PRODUCT</span><span>TOTAL</span></div>' : '';
    mount.innerHTML = `<div class="plain-cart plain-cart--${design.key}" role="img" aria-label="Illustrative standard ${design.brand} cart. Two Classic Cotton T-Shirts and one Premium Hoodie. Subtotal 119 dollars and 97 cents. Basic checkout without rewards or product recommendations."><div class="plain-cart__canvas" aria-hidden="true">${masthead(design)}<div class="plain-cart__body"><div class="plain-cart__heading"><span>${design.title}</span><span>${design.count}</span></div>${tableHead}${product(tee, 'Classic Cotton T-Shirt', design.variantOne, 2, '$59.98', design)}${product(hoodie, 'Premium Hoodie', design.variantTwo, 1, '$59.99', design)}</div><div class="plain-cart__footer"><div class="plain-cart__subtotal"><span>${design.subtotal}</span><span>$119.97</span></div><p class="plain-cart__shipping">${design.shipping}</p><span class="plain-cart__checkout">${design.checkout}</span><span class="plain-cart__continue">${design.back}</span></div></div></div>`;
    mount.dataset.brand = design.key;
    return mount.firstElementChild;
  }
  window.CartivateCounter = Object.freeze({render});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => render(0), {once: true});
  else render(0);
})();

/* Rotate only the two screen contents; the phones and hands stay anchored. */
(() => {
  const stage = document.querySelector('.cart-showcase');
  const image = stage?.querySelector('.hero-cart-shell img');
  if (!image) return;
  const screens = [...stage.querySelectorAll('.phone-screen')];
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const designs = [
    {src: image.src, alt: image.alt},
    {src: image.dataset.cartGud, alt: 'GUD Cartivate cart with navy typography, blush accents and a navy checkout button.'},
    {src: image.dataset.cartVelside, alt: 'Velside Cartivate cart with black and red motorsport styling.'}
  ];
  const loaded = designs.map(design => {
    const preload = new Image();
    preload.src = design.src;
    return preload.decode().then(() => true).catch(() => false);
  });
  let current = 0, changing = false, hovered = false, focused = false, onScreen = false, failed = false;
  let timer;
  const mayRotate = () => !motion.matches && !document.hidden && onScreen && !hovered && !focused && !failed;
  function schedule() {
    clearTimeout(timer);
    if (mayRotate() && !changing) timer = setTimeout(advance, 6000);
  }
  async function transition(frames, duration, easing) {
    if (motion.matches) return;
    const animations = screens.map(screen => screen.animate(frames, {duration, easing, fill: 'forwards'}));
    await Promise.all(animations.map(animation => animation.finished));
  }
  async function advance() {
    if (!mayRotate()) return;
    changing = true;
    const next = (current + 1) % designs.length;
    try {
      if (!(await loaded[next])) { failed = true; return; }
      if (!mayRotate()) return;
      await transition([
        {opacity: 1, transform: 'translateY(0)', filter: 'blur(0)'},
        {opacity: 0, transform: 'translateY(-3%)', filter: 'blur(3px)'}
      ], 220, 'cubic-bezier(.4,0,1,1)');
      image.src = designs[next].src;
      image.alt = designs[next].alt;
      window.CartivateCounter.render(next);
      current = next;
      screens.forEach(screen => screen.getAnimations().forEach(animation => animation.cancel()));
      await transition([
        {opacity: 0, transform: 'translateY(4%)', filter: 'blur(3px)'},
        {opacity: 1, transform: 'translateY(0)', filter: 'blur(0)'}
      ], 480, 'cubic-bezier(.16,1,.3,1)');
    } finally {
      screens.forEach(screen => screen.getAnimations().forEach(animation => animation.cancel()));
      changing = false;
      schedule();
    }
  }
  stage.addEventListener('pointerenter', () => { hovered = true; schedule(); });
  stage.addEventListener('pointerleave', () => { hovered = false; schedule(); });
  stage.addEventListener('focusin', () => { focused = true; schedule(); });
  stage.addEventListener('focusout', event => { focused = stage.contains(event.relatedTarget); schedule(); });
  document.addEventListener('visibilitychange', schedule);
  motion.addEventListener('change', schedule);
  if ('IntersectionObserver' in window) new IntersectionObserver(entries => {
    onScreen = entries[0].isIntersecting;
    schedule();
  }, {threshold: .2}).observe(stage);
  else { onScreen = true; schedule(); }
})();
